module.exports = {
          srcSet: __webpack_public_path__ + "img/20bafcc-250.png"+" 250w",
          images:[ {path: __webpack_public_path__ + "img/20bafcc-250.png",width: 250,height: 230}],
          src: __webpack_public_path__ + "img/20bafcc-250.png",
          toString:function(){return __webpack_public_path__ + "img/20bafcc-250.png"},
          
          width: 250,
          height: 230
        }